export default __webpack_public_path__ + "static/media/TitilliumWeb-Bold.a267a8b6.ttf";